import React, { Component } from 'react';
import { withOktaAuth } from "@okta/okta-react";
import axios from 'axios';
import { format, isAfter, isEqual } from 'date-fns';

import 'react-day-picker/lib/style.css';

// components
import Header from '../components/Header';
import Footer from '../components/Footer';
import Cleared from './Cleared';

export default withOktaAuth(
class Page extends Component {
  _isMounted = false;
  _form = false;

  constructor(props) {
    super(props);
    this.state = { campusSelect: null, redirect: null, fn: null, ln: null, em: null, le: null, event: null, txauEvents: [], txdaEvents: [], flmiEvents: [], flsaEvents: [], casmEvents: [] };
    // this.checkUser = checkUser.bind(this);

    this.reentryapi = process.env.REACT_APP_REENTRY_API;
  }

  componentDidMount() {
    this._isMounted = true;
    this._form = true;
    let self = this;

    // let sampleDate = {
    //   campus: 'St.Augustine',
    //   date: '2021-12-10 00:00:00',
    //   id: 10,
    //   name: 'Test Event',
    //   timestamp: '2021-11-04 13:29:29'
    // };
    // self.state.flsaEvents.push(sampleDate);
    // console.dir(self.state.flsaEvents);

    // self.setState({ isLoaded: true });

    axios.get(this.reentryapi+'/events/show/').then(res => {
      const events = res.data;
      // console.dir(events);
      const now = new Date();
      now.setDate(now.getDate() - 1);
      // console.dir(now);

      events.forEach(element => {
        const ed = element.date.slice(0,-9);
        const ed2 = ed.split('-');
        const ed3 = new Date(ed2[0], ed2[1]-1, ed2[2]);
        // console.dir('event: ' + ed3);

        // if (ed.getTime() > ne.getTime()) {
        if (isAfter(ed3, now) || isEqual(ed3, now)) {
          if (element.campus === 'Austin') self.state.txauEvents.push(element);
          if (element.campus === 'Dallas') self.state.txdaEvents.push(element);
          if (element.campus === 'Miami') self.state.flmiEvents.push(element);
          if (element.campus === 'San Marcos') self.state.casmEvents.push(element);
          if (element.campus === 'St. Augustine') self.state.flsaEvents.push(element);
        }
      });

      self.setState({
        isLoaded: true
      });
    })
    .catch(err => console.dir(err));

    const inputs = document.querySelectorAll('.form-input');
    const select = document.querySelector('select[name="event"]');

    select.addEventListener('change', function() {
      let selectedEvent = this.value;

      if (selectedEvent > 0 ) {
        self.setState({ event: selectedEvent });
        document.querySelector('#error_event').style.display='none';
      } else {
        self.setState({ event: null });
        document.querySelector('button[type="submit"]').disabled = true;
        document.querySelector('#error_event').style.display='block';
      }

      self.validateForm();
    });

    inputs.forEach((i) => {
      i.addEventListener('change', function() {
        if(i.id === 'first_name') {
          document.querySelector('#error_fn').style.display='none';
          this.setState({ fn : 'valid' });

          if (i.value === '') {
            this.setState({ fn : null });
            document.querySelector('#error_fn').style.display='block';
          }
        }

        if(i.id === 'last_name') {
          document.querySelector('#error_ln').style.display='none';
          this.setState({ ln : 'valid' });

          if (i.value === '') {
            document.querySelector('#error_ln').style.display='block';
            this.setState({ ln : null });
          }
        }

        if(i.id === 'email') {
          document.querySelector('#error_em').style.display='block';
          this.setState({ em : null });
        }

        if(i.id === 'email' && this.validateEmail(i.value) === true) {
          document.querySelector('#error_em').style.display='none';
          this.setState({ em : 'valid' });
          this.getUserInfo(i.value);
        }

        if(i.id === 'legal' && i.checked === true) {
          document.querySelector('#error_leg').style.display='none';
          this.setState({ le : 'valid' });
        }

        if(i.id === 'legal' && i.checked === false) {
          document.querySelector('#error_leg').style.display='block';
          document.querySelector('button[type="submit"]').disabled = true;
          this.setState({ le : null });
        }

        this.validateForm();
      }.bind(this))
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getUserInfo = (e) => {
    const email = e;
    let self = this;

    axios.get(this.reentryapi+'/vax/show/' + email).then(res => {
      const u = res.data[0];
      self.setState({ uid: u.id });
    })
    .catch(err => {
      console.dir(err);
      if (err.config.url.includes('/vax/show')) {
        console.log('no user');

        axios.post(self.reentryapi+'/api/adduser', {
          fname: document.querySelector('input#first_name').value,
          lname: document.querySelector('input#last_name').value,
          email: document.querySelector('input#email').value
        })
        .then(function (response) {
          console.log(response);
          self.setState({ uid: response.data.id });
        })
        .catch(function (error) {
          console.log(error);
        });
      };
    });
  }

  validateForm = () => {
    if (this.state.fn && this.state.ln && this.state.em && this.state.event !== null && this.state.le !== null)
      document.querySelector('button[type="submit"]').disabled = false;
  }

  campusSelect = (event) => {
    // reset the event in case they change campus
    this.setState({ event: null });
    document.querySelector('#error_event').style.display='block';
    document.querySelector('button[type="submit"]').disabled = true;

    let t = event.target.value.toLowerCase();
    // console.dir(this.state.[t+'Events']);

    this.setState({ campusSelect: event.target.value });
    if(this.state.[t+'Events'].length !== 0) {
      // set the campus and show the events for that campus
      document.querySelectorAll('.errors')[0].style.display = 'none';
      document.querySelector('.eventSelect').style.display = 'block';
      document.querySelector('.eventSelect select').disabled = false;
    } else {
      document.querySelectorAll('.errors')[0].style.display = 'block';
      document.querySelector('.eventSelect').style.display = 'none';
      document.querySelector('.eventSelect select').disabled = true;
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ redirect: 'completed' });

    // const fname = document.getElementById('first_name').value;
    // const lname = document.getElementById('last_name').value;
    // const email = document.getElementById('email').value;
    const uid = this.state.uid;
    const sEvent = this.state.event;

    // console.dir(data);
    // const addUser = axios.post(this.reentryapi+'/api/adduser/');
    // const postDocument = axios.post(this.reentryapi+'/document/create/');
    // const postForm = axios.post(this.reentryapi+'/form/create');

    axios.post(this.reentryapi+'/events/create', {
      uid: uid,
      eid: sEvent
    })
    .then(function (response) {
      console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    let { redirect, txauEvents, txdaEvents, flmiEvents, flsaEvents, casmEvents, campusSelect } = this.state;
    // let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    // console.dir(this.state);

    // Submitted, training complete, failed
    if (redirect === 'completed')
      return <Cleared data={ this.state } />

    // Return the form when the form is ready
    return (
      <>
        <Header />

        <div className="form">
          <div className="container">
            <div className="row">
              <div className="col-6 col-offset-3">
                <p>Welcome, please answer the questions below so we can verify if you are cleared to come to the University’s event today.</p>

                <form onSubmit={ this.submitForm.bind(this) }>
                  <div className="details">
                    <input name="first_name" id="first_name" placeholder="First Name" className="form-input" />
                    <input name="last_name" id="last_name" placeholder="Last Name" className="form-input" />
                    <input name="email" id="email" placeholder="Email Address" className="form-input" />

                    <div className="campusSelect">
                      <label htmlFor="campus">Select Campus</label>
                      <select name="campus" id="campus" className="form-input" onChange={ this.campusSelect }>
                        <option defaultValue></option>
                        <option value="TXAU">Austin, TX</option>
                        <option value="TXDA">Dallas, TX</option>
                        <option value="FLMI">Miami, FL</option>
                        <option value="CASM">San Marcos, CA</option>
                        <option value="FLSA">St. Augustine, FL</option>
                      </select>
                    </div>

                    <div className="errors">
                      <p id="error_noEvent">No events currently scheduled for this campus.</p>
                    </div>

                    <div className="eventSelect" style={{display:'none'}}>
                      <label htmlFor="event">Select Your Event</label>
                      <select name="event" id="event" className="form-input" disabled>
                        <option defaultValue></option>
                        {(campusSelect === 'TXAU') && (
                          <>
                          {txauEvents.map(function(event){
                            let d = event.date.split(' ');
                            let d2 = d[0].split('-');
                            return <option key={ event.id } value={ event.id }>{ event.name } - { format(new Date(d2[0], d2[1]-1, d2[2]),'MMM dd, yyyy') }</option>
                          })}
                          </>
                        )}

                        {(campusSelect === 'TXDA') && (
                          <>
                          {txdaEvents.map(function(event){
                            let d = event.date.split(' ');
                            let d2 = d[0].split('-');
                            return <option key={ event.id } value={ event.id }>{ event.name } - { format(new Date(d2[0], d2[1]-1, d2[2]),'MMM dd, yyyy') }</option>
                          })}
                          </>
                        )}

                        {(campusSelect === 'FLMI') && (
                          <>
                          {flmiEvents.map(function(event){
                            let d = event.date.split(' ');
                            let d2 = d[0].split('-');
                            return <option key={ event.id } value={ event.id }>{ event.name } - { format(new Date(d2[0], d2[1]-1, d2[2]),'MMM dd, yyyy') }</option>
                          })}
                          </>
                        )}

                        {(campusSelect === 'CASM') && (
                          <>
                          {casmEvents.map(function(event){
                            let d = event.date.split(' ');
                            let d2 = d[0].split('-');
                            return <option key={ event.id } value={ event.id }>{ event.name } - { format(new Date(d2[0], d2[1]-1, d2[2]),'MMM dd, yyyy') }</option>
                          })}
                          </>
                        )}

                        {(campusSelect === 'FLSA') && (
                          <>
                          {flsaEvents.map(function(event){
                            let d = event.date.split(' ');
                            let d2 = d[0].split('-');
                            return <option key={ event.id } value={ event.id }>{ event.name } - { format(new Date(d2[0], d2[1]-1, d2[2]),'MMM dd, yyyy') }</option>
                          })}
                          </>
                        )}
                      </select>
                    </div>
                  </div>

                  {/* Question 5 */}
                  <span className="q5">
                    <label htmlFor="question6">
                      <input type="checkbox" className="form-input" id="legal" />
                      <label htmlFor="legal"></label>
                      I agree to abide by USAHS rules on social distancing, handwashing, and face covering during the time I am at the event sponsored by USAHS.</label>

                    {/* <p className="italic one">By clicking submit:</p> */}
                    <ul className="nom">
                      <li className="italic"> I certify that my responses above are true and accurate to the best of my knowledge.</li>
                      <li className="italic">I agree that health and safety at University events is a shared responsibility and I will abide by the established USAHS guidelines.</li>
                    </ul>
                  </span>

                  <div className="errors">
                    <p id="error_fn">Please fill in your first name.</p>
                    <p id="error_ln">Please fill in your last name.</p>
                    <p id="error_em">Please fill in your valid email address.</p>
                    <p id="error_event">Please select your event.</p>
                    <p id="error_leg">Please agree to legal disclamer.</p>
                  </div>
                  <button type="submit" className="btn btn-primary" disabled>Submit</button>

                </form>

              </div>
            </div>
          </div>
        </div>

        {/* <div className="preloader">
          <div className="container">
            <div className="row">
              <div className="col-6 col-offset-3">
                <div className="loader"></div>
              </div>
            </div>
          </div>
        </div> */}

        <Footer />
      </>
    );
  }
}
);